import React, { Component } from 'react';
import { connect } from 'react-redux';
import {
  Table, TableBody, TableCell, TableHead, TableRow, Box, Typography, Button,
} from '@material-ui/core';
import {
  PROCESS_STATUS_MATCHING,
  ERROR_DOWNLOAD_BUTTON_DISP_STATUS,
  CHAR_CODE_MATCHING,
} from '../../../common/const';
import {
  setDispTab,
  searchMatchingJobList,
  filterJobList,
  fileCreateExecute,
  fileDownloadExecute,
} from '../../actions/MatchingAction';
import {
  setSystemLodingFLg,
} from '../../actions/CommonAction';
import styles from './MatchingResultComponent.module.css';
import MyIcon from '../common/MyIcon';

class MatchingResultComponent extends Component {
  /**
 * エラーダウンロードボタン押下時の処理
 * @param {*} fileName ファイル名
 */
  onClickErrDownload = async (fileName) => {
    const {
      selectJob,
      fileDownloadExecuteAct,
      setSystemLodingFLgAct,
    } = this.props;
    setSystemLodingFLgAct(true);
    // ファイルダウンロードAPI
    await fileDownloadExecuteAct(selectJob.seq_id, fileName);
    setSystemLodingFLgAct(false);
  }

  render() {
    const { selectJob } = this.props;

    // 設定ファイル名
    const fileName = selectJob.file_name;
    // アップロードメモ
    const uploadMemo = selectJob.upload_memo;
    let uploadMemoRecord;
    // アップロードメモ表示フラグ
    const uploadMemoDispFlg = [
      PROCESS_STATUS_MATCHING.MATCHING_PROCESSING,
      PROCESS_STATUS_MATCHING.SUCCESS,
    ].includes(selectJob.status);
    if (uploadMemoDispFlg) {
      uploadMemoRecord = (
        <TableRow className={`${styles.row}`}>
          <TableCell className={`${styles.rowTitle}`}>
            <Typography>アップロードメモ</Typography>
          </TableCell>
          <TableCell className={`${styles.itemCell}`}>
            <Typography className={`${styles.item}`}>{uploadMemo}</Typography>
          </TableCell>
        </TableRow>
      );
    }
    // 文字コード
    const charset = selectJob.charset === CHAR_CODE_MATCHING.SJIS ? 'Shift-JIS' : 'UTF-8';
    const charSetRecord = (
      <TableRow className={`${styles.row}`}>
        <TableCell className={`${styles.rowTitle}`}>
          <Typography>文字コード</Typography>
        </TableCell>
        <TableCell className={`${styles.itemCell}`}>
          <Typography className={`${styles.item}`}>{charset}</Typography>
        </TableCell>
      </TableRow>
    );
    // アップロード日時
    const uploadStartDate = selectJob.upload_datetime;
    const userId = selectJob.user_id;
    let uploadStartDateRecord;
    if (uploadStartDate) {
      uploadStartDateRecord = (
        <TableRow className={`${styles.row}`}>
          <TableCell className={`${styles.rowTitle}`}>
            <Typography className="title">アップロード日時</Typography>
          </TableCell>
          <TableCell className={`${styles.itemCell}`}>
            <Box display="flex" alignItems="center">
              <Typography className={`${styles.item}`}>{uploadStartDate}</Typography>
              <Typography className={`${styles.item}`}>
                (ユーザーID：
                {userId}
                )
              </Typography>
            </Box>
          </TableCell>
        </TableRow>
      );
    }
    // ステータス名
    const statusName = selectJob.status_name;
    // レコード件数
    const inputCount = `${Number(selectJob.input_count).toLocaleString()}件`;
    const countDispFlg = [
      PROCESS_STATUS_MATCHING.SUCCESS,
    ].includes(selectJob.status);
    // マッチング一致件数
    const matchCount = countDispFlg ? `${Number(selectJob.match_count).toLocaleString()}件` : '集計中';
    // マッチング不一致件数
    const unmatchCount = countDispFlg ? `${Number(selectJob.unmatch_count).toLocaleString()}件` : '集計中';

    // 結果非表示フラグ
    const notResultDispFlg = [
      PROCESS_STATUS_MATCHING.CHECK_PROCESSING,
      PROCESS_STATUS_MATCHING.CHECK_NG,
      PROCESS_STATUS_MATCHING.STOP,
      PROCESS_STATUS_MATCHING.ANOMALY,
    ].includes(selectJob.status);
    // エラーダウンロード表示フラグ
    const errDownloadFlg = ERROR_DOWNLOAD_BUTTON_DISP_STATUS.includes(selectJob.status);
    let errorDownloadButton;
    let resultList;
    if (notResultDispFlg) {
      if (errDownloadFlg) {
        const downloadFileName = (selectJob.file_name.indexOf('.tsv') !== -1
          ? selectJob.file_name.replace('.tsv', '').concat('_error.tsv') : selectJob.file_name.replace('.csv', '').concat('_error.csv'));
        errorDownloadButton = (
          <Button
            variant="contained"
            color="secondary"
            startIcon={<MyIcon className={`${styles.downloadIcon}`} type="download" />}
            onClick={() => this.onClickErrDownload(downloadFileName)}
            className={`${styles.btnSize}`}
          >
            ダウンロード
          </Button>
        );
      }
    } else {
      resultList = (
        <Table className={`${styles.matchingresultsfield}`}>
          <TableHead className={`${styles.header}`}>
            <TableRow>
              <TableCell colSpan={2} className={`${styles.headerTitle} ${styles.topRadius}`}>結果ダウンロード</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            <TableRow className={`${styles.row}`}>
              <TableCell colSpan={2} className={`${styles.itemCell} ${styles.commentCell}`}>
                <Typography className={`${styles.comment}`}>※ダウンロードファイルはアップロード時に指定した文字コードになります。</Typography>
              </TableCell>
            </TableRow>
            <TableRow className={`${styles.row}`}>
              <TableCell className={`${styles.rowTitle}`}>
                <Typography>レコード件数</Typography>
              </TableCell>
              <TableCell className={`${styles.itemCell}`}>
                <Box display="flex" alignItems="center">
                  <Typography className={`${styles.item}`}>
                    {inputCount || 0}
                  </Typography>
                </Box>
              </TableCell>
            </TableRow>
            <TableRow className={`${styles.row}`}>
              <TableCell className={`${styles.rowTitle}`}>
                <Typography>マッチング一致件数</Typography>
              </TableCell>
              <TableCell className={`${styles.itemCell}`}>
                <Typography className={`${styles.item}`}>
                  {matchCount || '0件'}
                </Typography>
              </TableCell>
            </TableRow>
            <TableRow className={`${styles.row}`}>
              <TableCell className={`${styles.rowTitle} ${styles.leftBottomRadius}`}>
                <Typography>マッチング不一致件数</Typography>
              </TableCell>
              <TableCell className={`${styles.itemCell} ${styles.rightBottomRadius}`}>
                <Typography className={`${styles.item}`}>
                  {unmatchCount || '0件'}
                </Typography>
              </TableCell>
            </TableRow>
          </TableBody>
        </Table>
      );
    }
    return (
      <Box className={`${styles.matchingresults}`}>
        <Box display="flex" alignItems="center" flexDirection="column" className={`${styles.matchingresultsframe}`}>
          <Table className={`${styles.matchingresultsfield}`}>
            <TableHead className={`${styles.header}`}>
              <TableRow>
                <TableCell colSpan={2} className={`${styles.headerTitle} ${styles.topRadius}`}>マッチング結果</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              <TableRow className={`${styles.row}`}>
                <TableCell className={`${styles.rowTitle}`}>
                  <Typography>設定ファイル名</Typography>
                </TableCell>
                <TableCell className={`${styles.itemCell}`}>
                  <Box display="flex" alignItems="center">
                    <Typography className={`${styles.item} ${styles.fileName}`}>{fileName}</Typography>
                  </Box>
                </TableCell>
              </TableRow>
              {uploadMemoRecord}
              {uploadStartDateRecord}
              {charSetRecord}
              <TableRow className={errDownloadFlg ? `${styles.rowBtn}` : `${styles.row}`}>
                <TableCell className={`${styles.rowTitle} ${styles.leftBottomRadius}`}>
                  <Typography>状態</Typography>
                </TableCell>
                <TableCell className={`${styles.rightBottomRadius} ${styles.itemCell}`}>
                  <Box display="flex" alignItems="center">
                    <Typography className={`${styles.item} ${styles.statusName}`}>{statusName}</Typography>
                    <Box className={`${styles.buttondiv}`}>{errorDownloadButton || ''}</Box>
                  </Box>
                </TableCell>
              </TableRow>
            </TableBody>
          </Table>
          {resultList}
        </Box>
      </Box>
    );
  }
}

export default connect(
  (state) => ({
    selectJob: state.matching.selectJob,
  }),
  (dispatch) => ({
    setSystemLodingFLgAct: (bool) => dispatch(setSystemLodingFLg(bool)),
    setDispTabAct: (str) => dispatch(setDispTab(str)),
    searchMatchingJobListAct: (excutionDate) => dispatch(searchMatchingJobList(excutionDate)),
    filterJobListAct: () => dispatch(filterJobList()),
    fileCreateExecuteAct: (seqId, charCode, delimiter) => dispatch(fileCreateExecute(
      seqId, charCode, delimiter,
    )),
    fileDownloadExecuteAct: (seqId, fileName) => dispatch(fileDownloadExecute(
      seqId, fileName,
    )),
  }),
)(MatchingResultComponent);
